import React, {Component} from 'react';

class StatsBox extends Component {

    render() {
        return (
            <div
                className={this.props.color === "red" ? "dashboard_gral-stats_box" : "dashboard_gral-stats_box blue-box"}>
                <div className="dashboard_gral-stats_box_inner">
                    <div className="dashboard_gral-stats_box_inner_top-bar">
                        <div className="dashboard_gral-stats_box_inner_top-bar_load">

                        </div>
                    </div>
                    {!this.props.fetchingData &&
                    <div>
                        <div className="dashboard_gral-stats_box_inner_main">
                            <div className="row">
                                <div className="col s12">
                                    <img src={this.props.img} className="" alt=""/>
                                    <h3>{this.props.data}</h3>
                                    <span>
                                            {this.props.secondaryData &&
                                            <span>{this.props.secondaryData}</span>
                                            }
                                        {this.props.comment}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard_gral-stats_box_inner_secondary">
                            <div className="row">
                                <div className="col s12">
                                    <h4>{this.props.text}</h4>
                                    <span>{this.props.subtext}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {this.props.fetchingData &&
                        <div className={"loader-box small"}/>
                    }

                </div>
            </div>
        );
    }
}


export default StatsBox;


// WEBPACK FOOTER //
// ./src/containers/dashboard/components/statsBox/StatsBox.js